import React from 'react'
import axios from 'axios';
import { format } from 'date-fns'
import moment from 'moment';
import { Badge, Calendar, Alert, List } from 'antd'
import 'antd/dist/antd.css'

import ErrorSwal from '../components/SwalError'
import { LeaveEvent, CompanyEvent } from '../components/functions/CalendarPage'
import { DashboardCheckEventDay } from '../components/functions/DashboardPage'
// import { LeaveEvent, CompanyEvent, FindOneEvent } from '../components/functions/CalendarPage'
// import { FindOne } from '../components/functions/LeaveRequestPage'
// import CalendarLeave from '../components/Modal/CalendarLeave'
// import CalendarHoliday from '../components/Modal/CalendarHoliday'


const FullCalendar = () => {


    const cancelToken = React.useRef(null)
    const [error, setError] = React.useState()
    const [event, setEvent] = React.useState([])
    const [eventDay, setEventDay] = React.useState([])
    const [selectedValue, setSelectedValue] = React.useState(moment());
    const [isLoading, setIsLoading] = React.useState(false);

    // const [isModalVisible, setIsModalVisible] = React.useState(false)
    // const [isModalVisible2, setIsModalVisible2] = React.useState(false)
    // const [holiday, setHoliday] = React.useState({})
    // const [values, setValues] = React.useState({
    //     EmpNo: '',
    //     LeaveID: '',
    //     LeaveType: '',
    //     Reason: '',
    //     Status: '',
    //     Amount: '',
    //     Time: '',
    //     ToDate: '',
    //     EndDate: '',
    //     ToTime: '',
    //     EndTime: '',
    // })

    const getData = async () => {
        try {

            setIsLoading(true);
            const Event1 = await LeaveEvent()
            const Event2 = await CompanyEvent()

            setEvent(Event1.data.LeaveCalendar.concat(Event2.data.CalendarEvent));

        } catch (error) {
            if (error?.response?.data) {
                const { data } = error.response
                setError(data.message)
            }
            setIsLoading(false);
        }
        finally {
            setIsLoading(false);
        }
    }
    React.useEffect(() => {
        cancelToken.current = axios.CancelToken.source();

        getData();

        return () => {
            cancelToken.current.cancel();
        };
    }, [])

    if (isLoading) {
        // return (
        //     <div className="spinner-border" role="status">
        //         <span className="sr-only">Loading...</span>
        //     </div>
        // )
    }

    if (error) {
        ErrorSwal({ title: 'Error', text: error, icon: 'error' })
        setError(null);
    }


    const onSelect = async (info) => {
        let day = format(new Date(info.year(), info.month(), info.date()), 'yyyy-MM-dd')
        const resp = await DashboardCheckEventDay(day)
        setSelectedValue(info)
        setEventDay(resp.data.calendarLists)

    }


    const getListData = (value) => {
        let listData;

        event?.forEach((item) => {
            if (item.year === value.year()) {
                if (item.month === value.month()) {
                    if (item.date === value.date()) {
                        listData = [item]
                    }

                }
            }
        })

        // console.log(listData)
        return listData || [];
    };

    const dateCellRender = (value) => {
        const listData = getListData(value);
        return (
            <ul className="events">
                {listData.map((item) => (
                    <li key={item.content}>
                        <Badge color={item.color} text={item.content} />
                    </li>
                ))}
            </ul>
        );
    };


    // const handelClick = async (info) => {
    //     const id = info.event._def.extendedProps.no
    //     const type = info.event._def.extendedProps.type
    //     if (type === "leave") {
    //         await FindOne(id)
    //             .then((response) => {

    //                 setValues({
    //                     ...values,
    //                     EmpNo: response.data.leave.EMP_NO,
    //                     LeaveID: response.data.leave.LEAVE_NO,
    //                     LeaveType: response.data.leave.TYPECD,
    //                     Reason: response.data.leave.REASON,
    //                     Status: response.data.leave.STATUS,
    //                     Amount: response.data.leave.DAYS_QTY,
    //                     Time: response.data.leave.MIN_QTY,
    //                     ToDate: (format(new Date(response.data.leave.BEGIN_DT), 'dd/MM/yyyy')),
    //                     EndDate: (format(new Date(response.data.leave.END_DT), 'dd/MM/yyyy')),
    //                     ToTime: response.data.leave.BEGIN_TIME,
    //                     EndTime: response.data.leave.END_TIME,
    //                     leaveTypes: response.data.leave.leaveTypes
    //                 })

    //                 setIsModalVisible(true);
    //             })
    //             .catch(error => {
    //                 if (error?.response?.data) {
    //                     const { data } = error.response
    //                     setError(data.message)
    //                 }
    //             })
    //     }
    //     else {
    //         await FindOneEvent(id)
    //             .then((response) => {
    //                 console.log(response.data)
    //                 setHoliday({
    //                     ...holiday,
    //                     COMPANY: response.data.Events.COMPANY,
    //                     DESCRIPTION: response.data.Events.DESCRIPTION,
    //                     BEGIN_DT: response.data.Events.BEGIN_DT
    //                 })

    //                 setIsModalVisible2(true);
    //             })
    //             .catch(error => {
    //                 if (error?.response?.data) {
    //                     const { data } = error.response
    //                     setError(data.error)
    //                 }
    //             })
    //     }


    // }


    return (
        <>
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card" >
                            <div className="card-content">
                                <div className="card-body">
                                    <Alert message={`You selected date: ${selectedValue?.format('YYYY-MM-DD')} `} />
                                    <Calendar dateCellRender={dateCellRender} onSelect={onSelect} />
                                    {
                                        eventDay.length > 0 ? (
                                            <List
                                                itemLayout="horizontal"
                                                bordered={true}
                                                size="small"
                                                dataSource={eventDay}
                                                renderItem={item => (
                                                    <List.Item>
                                                        <List.Item.Meta
                                                            title={`${item.title} : ${item.reason} , ${format(new Date(item.to), 'dd/MM/yyyy')} - ${format(new Date(item.end), 'dd/MM/yyyy')}`}
                                                        />
                                                    </List.Item>
                                                )}
                                            />
                                        ) : (
                                            <p></p>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* {isModalVisible ? <CalendarLeave isOpen={isModalVisible} isModalVisible={setIsModalVisible} values={values} /> : null}
            {isModalVisible2 ? <CalendarHoliday isOpen={isModalVisible2} isModalVisible={setIsModalVisible2} values={holiday} /> : null} */}


        </>
    )
}

export default FullCalendar
